import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, useRouter, useContext } from '@nuxtjs/composition-api';
import PortfolioButton from '@/components/partials/public-portfolio/PortfolioButton/PortfolioButton.vue';
import { EDIT_SECTION_EVENT_NAME } from '@/components/partials/public-portfolio/constants';
import type { SectionMode } from '@/components/partials/public-portfolio/types';

type PublicPortfolioWorkHistoryProps = {
  workHistoryId?: number;
  image?: string;
  position?: string;
  company?: string;
  startedAt?: string;
  finishedAt?: string;
  mode?: SectionMode;
  slug?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioWorkHistory',
  props: {
    workHistoryId: { default: -1 },
    image: { default: '' },
    position: { default: '' },
    company: { default: '' },
    startedAt: { default: '' },
    finishedAt: { default: '' },
    mode: { default: 'view' },
    slug: { default: '' }
  },
  setup(__props: any) {

const props = __props as { workHistoryId: number, image: string, position: string, company: string, startedAt: string, finishedAt: string, mode: SectionMode, slug: string };



const router = useRouter();
const { $analytics, $constants } = useContext();

const isImageFailed = ref(false);

const link = computed(() => {
  if (!props.slug) return '';
  return `/salaries/company/${props.slug}/people/`;
});
const containerComponent = computed(() => (link.value ? 'a' : 'div'));
const containerClasses = computed(() => ({
  'public-portfolio-work-history__container': true,
  'public-portfolio-work-history__container--link': Boolean(link.value),
}));
const showImage = computed(() => Boolean(props.image) && !isImageFailed.value);

function handleEdit() {
  $analytics?.logEvent(EDIT_SECTION_EVENT_NAME, { name: 'job' });
  router.push(
    `?dynamic_modal=${$constants.dynamicModals.PUBLIC_PORTFOLIO_EDIT_WORK_HISTORY_MODAL}&wh-id=${props.workHistoryId}`,
  );
}

function handleError() {
  isImageFailed.value = true;
}

return { __sfc: true,props, router, $analytics, $constants, isImageFailed, link, containerComponent, containerClasses, showImage, handleEdit, handleError, PortfolioButton }
}

})